import { autoinject } from "aurelia-framework";
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationControllerFactory, ValidationController, validateTrigger } from 'aurelia-validation';
import { UrlService } from '_services/url-service';
import { HttpClient } from 'aurelia-http-client';
import * as Dto from '_models/dtos';

@autoinject
export class FeedbackDialog {
    private _url: UrlService;
    private _http: HttpClient;

    constructor(
        public controller: DialogController,
        validationControllerFactory: ValidationControllerFactory
    ) {
        this._url = new UrlService();
        this._http = new HttpClient();

        this.validation = validationControllerFactory.createForCurrentScope();
        this.validation.validateTrigger = validateTrigger.change;
        this.feedback = new Dto.Feedback();

        ValidationRules
            .ensure((f: Dto.Feedback) => f.firstName).required()
            .ensure((f: Dto.Feedback) => f.lastName).required()
            .ensure((f: Dto.Feedback) => f.email).required().email()
            .ensure((f: Dto.Feedback) => f.feedback).required()
            .on(this.feedback);
    }

    validation: ValidationController;

    feedback: Dto.Feedback;

    isSending = false;

    /**
      * This field is fake and is used only as a "honeypot" captcha
      */
    details: string = '';
    
    cancel() {
        this.controller.cancel();
    }

    send() {

        this.validation.validate().then(result => {

            var isBot = this.details != '';

            if (isBot) {

                // Close dialog and do nothing
                this.controller.cancel();

            } else if (result.valid) {

                this.isSending = true;

                try {

                    // Send feedback via SMTP
                    var url = this._url.build('~/api/Feedback');
                    var req = this.feedback;
                    this._http.post(url, req).then(resp => {

                        if (!resp.content.isSuccess) {
                            // SMTP failed -- fallback
                            this.sendManually(resp.content.feedbackEmail)
                        }

                        // Close dialog
                        this.controller.ok();
                    });

                } catch (ex) {
                    this.isSending = false;

                }
            }
        });
    }

    sendManually(feedbackEmail: string) {
        // Send feedback email
        var f = this.feedback;
        var mailto = feedbackEmail;
        var subject = 'Spec Writer Web Feedback';
        var bodyAndSignature = `${f.feedback}%0A%0A${f.firstName} ${f.lastName}%0A${f.email}%0A`;
        window.open(`mailto:${mailto}?subject=${subject}&body=${bodyAndSignature}`, '_self');        
    }
}

